// Localized slugs for pages whose URL differs per language, plus the registry
// of pages that are FULLY translated this round (used for noindex + switcher).

export const SLUG_MAP = {
  doctorReview: {
    en: "how-we-review-doctors-and-providers",
    fr: "comment-nous-evaluons-les-chirurgiens-et-les-prestataires",
    de: "wie-wir-chirurgen-und-anbieter-pruefen",
  },
  aftercare: {
    en: "international-patient-aftercare-vietnam",
    fr: "suivi-postoperatoire-patients-internationaux-vietnam",
    de: "nachsorge-fuer-internationale-patienten-vietnam",
  },
};

export const getLocalizedSlug = (key, lang) => (SLUG_MAP[key] && SLUG_MAP[key][lang]) || SLUG_MAP[key].en;

// Given any pathname segment, return the page key if it is a localized slug.
export function pageKeyFromSlug(slug) {
  for (const key of Object.keys(SLUG_MAP)) {
    const variants = SLUG_MAP[key];
    if (Object.values(variants).includes(slug)) return key;
  }
  return null;
}

// English base paths that are fully translated (no English fallback) for FR/DE.
// These become index,follow in their language and are added to the sitemap.
// The homepage and long SEO articles are intentionally excluded this round and
// remain noindex,follow with the translation notice until fully translated.
const COMMON_TRANSLATED = [
  "/about",
  "/contact",
  "/patient-journey",
  "/editorial-policy",
  "/privacy-policy",
  "/terms",
  "/medical-disclaimer",
  "/cookie-policy",
  "/image-consent-policy",
  "/__doctor-review__",
  "/__aftercare__",
];

export const TRANSLATED_PAGES = {
  fr: new Set(COMMON_TRANSLATED),
  de: new Set(COMMON_TRANSLATED),
};

// Is the given English base path fully translated for this language?
export function isTranslated(basePath, lang) {
  if (lang === "en") return true;
  const set = TRANSLATED_PAGES[lang];
  return set ? set.has(basePath) : false;
}
